import client from "../../../../../shared/api/client";

const confirmPath = (teamId, confirmId) => `/teams/${teamId}/confirms/${confirmId}`;

export const fetchGuestList = ({ teamId, confirmId }) =>
  client.get(`${confirmPath(teamId, confirmId)}/guest_list_entries`);

export const previewGuests = ({ teamId, confirmId, listName, text }) =>
  client.post(`${confirmPath(teamId, confirmId)}/guest_list_preview`, { list_name: listName, text });

export const addGuests = ({ teamId, confirmId, listName, text }) =>
  client.post(`${confirmPath(teamId, confirmId)}/guest_list_entries`, { list_name: listName, text });

export const updateGuest = ({ teamId, confirmId, guestId, name, listName }) =>
  client.patch(`${confirmPath(teamId, confirmId)}/guest_list_entries/${guestId}`, { name, list_name: listName });

export const removeGuest = ({ teamId, confirmId, guestId }) =>
  client.delete(`${confirmPath(teamId, confirmId)}/guest_list_entries/${guestId}`);

export const updateGuestList = ({ teamId, confirmId, manifested }) =>
  client.patch(`${confirmPath(teamId, confirmId)}/guest_list`, { manifested });
